<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{
          $t("CRUD.chooseInfo", [$t("Role.StockPermissionFields.ObjectName")])
        }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="distribution_centers"
        :loading="loading"
        :search="filter"
        multi-sort
        class="elevation-0 px-6"
        fixed-header
        height="360px"
        v-resize="resizeHeader"
        :footer-props="footerProps"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            class="transparent-background-color"
            align-self="center"
          >
            <v-spacer />
            <v-row no-gutters class="me-n3">
              <v-spacer />
              <v-col cols="12" sm="9" md="8">
                <v-text-field
                  v-model="filter"
                  clearable
                  hide-details
                  :label="$t('Search.filter')"
                />
              </v-col>
            </v-row>
          </v-toolbar>
          <v-divider />
        </template>
        <template v-slot:header.check>
          <v-checkbox
            class="mt-2 mb-n3"
            color="primary"
            :indeterminate="
              distribution_centers.find((detail) => detail.check != checkAll) ? true : false
            "
            v-model="checkAll"
          >
            <template v-slot:label>
              <span class="caption ms-n2">
                {{ $t("Role.TemplatePermissionFields.check_all") }}
              </span>
            </template>
          </v-checkbox>
        </template>
        <template v-slot:item.check="{ item }">
          <div class="d-flex mt-n2 mb-n3">
            <v-checkbox
              color="primary"
              v-model="item.check"
              :true-value="1"
              :false-value="0"
            >
            </v-checkbox>
          </div>
        </template>
      </v-data-table>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          color="accent"
          @click="
            $emit(
              'confirm',
              distribution_centers.filter((d) => d.check)
            );
            dialog = false;
          "
        >
          {{
            $t("CRUD.confirmWithChooseCount", [
              distribution_centers.length ? distribution_centers.filter((s) => s.check).length : 0,
            ])
          }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import DistributionCenters from "@/api/distribution_centers";

export default {
  name: "DialogDistributionCenters",

  components: {},

  props: {
    value: Boolean,
    stockSelected: Array,
    type: Array,
  },

  computed: {
    headers() {
      return [
        {
          text: i18n.t("Role.StockPermissionFields.code"),
          align: "start",
          sortable: false,
          value: "code",
        },
        {
          text: i18n.t("Role.StockPermissionFields.name"),
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: i18n.t("Role.StockPermissionFields.check_all"),
          align: "start",
          sortable: false,
          value: "check",
        },
      ];
    },

    footerProps() {
      return Object.assign({}, i18n.t("$config.footer-props"), {
        itemsPerPageOptions: [this.itemsPerPageOptions],
      });
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    dialog: false,
    showSelected: [],
    filter: "",
    distribution_centers: [],
    paging: {},
    itemsPerPageOptions: 10,
    checkAll: 0,
  }),

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.dialog) {
          // 每次打开对话框重置查询
          this.getStocksFromAPI();
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.distribution_centers = [];
      },
    },
    checkAll: {
      handler() {
        this.distribution_centers = this.distribution_centers.map(
          function (detail) {
            detail.check = this.checkAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
  },

  methods: {
    resizeHeader() {
      this.itemsPerPageOptions = window.innerHeight > 800 ? 10 : 5;
    },

    getStocksFromAPI() {
      var data = {};
      if (this.type && this.type.length) {
        data = Object.assign({}, data, { type: this.type });
      }
      DistributionCenters.fetch(data).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.distribution_centers = response.data.distribution_centers.map((item) => {
              this.stockSelected.forEach((selected) => {
                if (selected.id == item.id) {
                  item.check = 1;
                }
              });

              return item;
            });
          }
        }.bind(this)
      );
    },
  },
};
</script>
